import React from "react";
import { useTranslation } from "react-i18next";
import { ICellRendererParams } from "@ag-grid-community/core";

import { InfoPlate } from "fe-shared/src/components";

import { INVOICE_STATUSES_CONFIG_MAP } from "../../../consts";

import { GridInvoice } from "../../../types";

import styles from "./StatusRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: GridInvoice;
}

const StatusRenderer = ({ data }: Props) => {
  const { t } = useTranslation();
  const { statusCode } = data;
  const variant = statusCode && INVOICE_STATUSES_CONFIG_MAP[statusCode];

  return (
    <div className={styles.status}>
      <InfoPlate variant={variant}>
        {t(`invoices.statuses.${statusCode}`)}
      </InfoPlate>
    </div>
  );
};

export default StatusRenderer;
